export default __webpack_public_path__ + "static/media/google-play-disabled.5007a7b9.svg";